// 系统路由配置
import { RouteRecordRaw } from 'vue-router';
import Layout from '@/Layout/MainLayout.vue';
import { PermissionType } from './types';

/**
 * 基础路由（无需权限验证）
 */
export const basicRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
    meta: {
      title: '登录',
      icon: 'Setting',
      hidden: true
    }
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: () => import('@/views/error/403.vue'),
    meta: {
      title: '无权限',
      hidden: true
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '页面不存在',
      hidden: true
    }
  }
];

/**
 * 权限路由（需要权限验证）
 */
export const permissionRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/config/school',
    meta: {
      title: '首页'
    },
    children: [
      // 配置管理模块
      {
        path: '/config',
        name: 'Config',
        meta: {
          title: '配置管理',
          icon: 'Menu',
        },
        children: [
          {
            path: 'school',
            name: 'School',
            component: () => import('@/views/config/SchoolManage.vue'),
            meta: {
              title: '学校管理',
              permission: PermissionType.SchoolManage
            }
          },
          {
            path: 'user-evaluation',
            name: 'UserEvaluation',
            component: () => import('@/views/config/UserEvaluation.vue'),
            meta: {
              title: '用户评价管理',
              permission: PermissionType.UserEvaluation
            }
          },
          {
            path: 'evaluation-item',
            name: 'EvaluationItem',
            component: () => import('@/views/config/EvaluationItems.vue'),
            meta: {
              title: '评价项管理',
              permission: PermissionType.EvaluationItems
            }
          },
          // {
          //   path: 'user-manage',
          //   name: 'UserManage',
          //   component: () => import('@/views/config/UserManage.vue'),
          //   meta: {
          //     title: '用户管理',
          //     permission: PermissionType.UserManage
          //   }
          // },
          {
            path: 'abnormal-user',
            name: 'AbnormalUser',
            component: () => import('@/views/config/AbnormalUser.vue'),
            meta: {
              title: '异常用户管理',
              permission: PermissionType.AbnormalUser
            }
          },
          {
            path: 'satisfaction-rule',
            name: 'SatisfactionRule',
            component: () => import('@/views/config/SatisfactionRule.vue'),
            meta: {
              title: '满意率规则配置',
              permission: PermissionType.SatisfactionRule
            }
          },
          {
            path: 'banner-config',
            name: 'BannerConfig',
            component: () => import('@/views/config/BannerConfig.vue'),
            meta: {
              title: 'banner内容配置',
              permission: PermissionType.BannerConfig
            }
          }
        ]
      },
      
      // 统计分析模块
      {
        path: '/stats',
        name: 'Stats',
        meta: {
          title: '统计分析',
          icon: 'TrendCharts'
        },
        children: [
          {
            path: 'periodic_statistical_comparison',
            name: 'PeriodicStatisticalComparison',
            component: () => import('@/views/statistic/PeriodicStatisticalComparison.vue'),
            meta: {
              title: '周期统计对比',
              permission: PermissionType.StatisticHome
            }
          },
          {
            path: 'comprehensive_satisfaction_rate_statistics',
            name: 'ComprehensiveSatisfactionRateStatistics',
            component: () => import('@/views/statistic/ComprehensiveSatisfactionRateStatistics.vue'),
            meta: {
              title: '综合满意率统计',
              permission: PermissionType.StatisticHome
            }
          },
          {
            path: 'statistics_satisfaction_content',
            name: 'StatisticsSatisfactionContent',
            component: () => import('@/views/statistic/StatisticsSatisfactionContent.vue'),
            meta: {
              title: '评价内容满意率统计',
              permission: PermissionType.StatisticHome
            }
          },
          {
            path: 'statistics_evaluation_content',
            name: 'StatisticsEvaluationContent',
            component: () => import('@/views/statistic/StatisticsEvaluationContent.vue'),
            meta: {
              title: '评价内容统计',
              permission: PermissionType.StatisticHome
            }
          },
          // {
          //   path: 'detailed_data',
          //   name: 'DetailedData',
          //   component: () => import('@/views/statistic/DetailedData.vue'),
          //   meta: {
          //     title: '详细数据',
          //     permission: PermissionType.DetailedData
          //   }
          // }
        ]
      }
    ]
  },
  // 404路由（放在最后）
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    meta: {
      title: '404',
      hidden: true
    }
  }
];